import { createAction, props } from '@ngrx/store';

export const changeFilter = createAction('[Revenue Filter] Change Filter', props<{ startDate: Date; endDate: Date }>());
